import React, { FC, Fragment, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';

import { TeamPoints } from '../team-points/team-points';
import { Button, CentreHeading, devices, PageTitle, SectionWrapper } from '../common-styles/common-styles';
import { isLoggedIn } from '../../app/authentication/auth';
import { TourTotals, useFetchTotalsPoints } from '../../api/hooks/use-fetch-totals-points';
import { SelectedIndexContext } from '../../App';
import { IndividualStandings } from '../standings/Individual-standings';
import { ResultsAsList } from '../results/ryderCup/results-as-list';
import { TeamGameIndividualStandings } from '../standings/team-game-individual-standings';
import { TeamGameResults } from '../results/team-games/team-game-results';
import { RYDER_CUP_TYPE, STABLEFORD_WITH_TEAM_GAMES } from '../../app/constants';

export const CommonPageContent = styled.div`
  border: 1px solid #736d6d;
  font-size: 15px;
  position: relative; /* Position the background text */
  bottom: 0; /* At the bottom. Use top:0 to append it to the top */
  /* background: rgba(0, 75, 112, 0.3); Black background with 0.5 opacity */
  background: white; /* Black background with 0.5 opacity */
  color: #f1f1f1; /* Grey text */
  color: black; /* Grey text */
  padding: 1rem; /* Some padding */
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 2px 2px 2px #736d6d;
  margin-top: 0.5rem;

  p {
    font-size: 14px;
  }

  h1 {
    font-size: 20px;
    margin-top: 0;
    margin-bottom: 12px;
    font-weight: 400;
  }

  @media ${devices.tablet} {
    /* background: rgba(0, 75, 112, 0.3); /*Black background with 0.5 opacity */
    background: white;
    margin: 10px;
    font-size: 16px;
    padding: 20px;

    p {
      font-size: 20px;
      margin-top: 20px;
    }

    h1 {
      font-size: 30px;
      font-weight: 400;
    }
  }
  @media ${devices.laptop} {
    border-radius: 5px;
    border-radius: 15px;
    box-shadow: 2px 2px 2px gray;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  position: relative;
`;
export const HomePage: FC = () => {
  const params = useParams();
  const { selectedTournamentIndex } = useContext(SelectedIndexContext);
  const [tourIndex, setTourIndex] = useState<number>(params.previousTournamentIndex ? Number(params.previousTournamentIndex) : selectedTournamentIndex);
  const navigate = useNavigate();

  const { data, error, isLoading } = useFetchTotalsPoints(tourIndex as number);
  const userIsAdmin = isLoggedIn();

  useEffect(() => {
    if (params.previousTournamentIndex) {
      setTourIndex(Number(params.previousTournamentIndex));
    } else {
      setTourIndex(selectedTournamentIndex);
    }
  }, [params, selectedTournamentIndex]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.log('<><Home Page Error><', error);
    return <div>Error</div>;
  }
  const teamTotals = data as TourTotals;
  if (teamTotals && teamTotals.tourType === RYDER_CUP_TYPE && teamTotals.totalsPointsData?.teamsCreated) {
    return (
      <SectionWrapper>
        <CommonPageContent>
          <CentreHeading>
            <h2>Team Standings</h2>
          </CentreHeading>
          <TeamPoints teamTotals={teamTotals.totalsPointsData} />
        </CommonPageContent>
        {teamTotals.config.showCaptainsRace && (
          <CommonPageContent>
            <IndividualStandings individualPoints={teamTotals.totalsPointsData.totalsPoints.individual} captainsPoints={teamTotals.totalsPointsData.totalsPoints.captainsRace} />
          </CommonPageContent>
        )}
        {!teamTotals.config.showCaptainsRace && (
          <SectionWrapper>
            <CommonPageContent>
              <CentreHeading>
                <h2>Individual Standings</h2>
              </CentreHeading>
              <TeamGameIndividualStandings individualPoints={teamTotals.totalsPointsData.totalsPoints.individual} config={teamTotals.config} />
            </CommonPageContent>
          </SectionWrapper>
        )}
        <CommonPageContent>
          <ResultsAsList tournamentIndex={tourIndex} config={teamTotals.config} />
        </CommonPageContent>
      </SectionWrapper>
    );
  }

  if (teamTotals && teamTotals.tourType === STABLEFORD_WITH_TEAM_GAMES && teamTotals.individualStandings?.length) {
    return (
      <SectionWrapper>
        <CentreHeading>
          <h2>Individual Stableford</h2>
        </CentreHeading>
        <TeamGameIndividualStandings individualPoints={teamTotals.individualStandings} config={teamTotals.config} />
        <TeamGameResults tournamentIndex={tourIndex} />
      </SectionWrapper>
    );
  }

  if (teamTotals.tourType === STABLEFORD_WITH_TEAM_GAMES) {
    return (
      <SectionWrapper>
        <div>Awaiting match entry</div>
      </SectionWrapper>
    );
  }

  if (teamTotals.tourType === RYDER_CUP_TYPE) {
    return (
      <div>
        <ButtonWrapper>
          {userIsAdmin && (
            <Button data-testid="add-teams" onClick={() => navigate('/create-teams')}>
              Add Teams
            </Button>
          )}
        </ButtonWrapper>
        <div>Awaiting team entry</div>
      </div>
    );
  }

  return (
    <div>
      <div>Awaiting result entry</div>
    </div>
  );
};
